//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WorkNav from "./componets/WorkNav";
import Consult from "./consult/consult";
import Complain from "./complaint/complain";
import Repairs from "./repair/repairs";


export default {
  name: "workSheets",
  components: {
    WorkNav,
    Consult,
    Complain,
    Repairs
  },
  data() {
    return {
      activeName: 'a',
      orderSelectPermission: {},
      saving: false
    }
  },
  methods: {
    getOrderSelectPermission() {
      this.saving = true
      abp.ajax.post('api/services/app/WorkOrder/MWorkOrderSelectPermission').then(res => {

        this.orderSelectPermission = {};
        this.orderSelectPermission = res.data.result;

      }).finally(() => {
        this.saving = false
      })
    }
  },
  created() {
    this.getOrderSelectPermission()
  }
};
